export default "__VITE_ASSET__CjCMrRdl__"